// extracted by mini-css-extract-plugin
module.exports = {"card":"UnauthorizedPage_card__3u-zs"};